"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _jsxFileName = "/codebuild/output/src2887346459/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Input/lib/Input.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_23vybfxuk0() {
  var path = "/codebuild/output/src2887346459/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Input/lib/Input.js";
  var hash = "1b50abbe506ef21d4588ea187a3ee625f1d07441";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2887346459/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Input/lib/Input.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 18
        },
        end: {
          line: 11,
          column: 34
        }
      },
      "1": {
        start: {
          line: 13,
          column: 16
        },
        end: {
          line: 15,
          column: 4
        }
      },
      "2": {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 58,
          column: 1
        }
      },
      "3": {
        start: {
          line: 18,
          column: 29
        },
        end: {
          line: 18,
          column: 46
        }
      },
      "4": {
        start: {
          line: 19,
          column: 19
        },
        end: {
          line: 19,
          column: 29
        }
      },
      "5": {
        start: {
          line: 20,
          column: 27
        },
        end: {
          line: 20,
          column: 45
        }
      },
      "6": {
        start: {
          line: 21,
          column: 34
        },
        end: {
          line: 21,
          column: 94
        }
      },
      "7": {
        start: {
          line: 31,
          column: 10
        },
        end: {
          line: 33,
          column: 23
        }
      },
      "8": {
        start: {
          line: 37,
          column: 10
        },
        end: {
          line: 38,
          column: 29
        }
      },
      "9": {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 54,
          column: 29
        }
      },
      "10": {
        start: {
          line: 60,
          column: 21
        },
        end: {
          line: 81,
          column: 1
        }
      },
      "11": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 92
        }
      },
      "12": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 92
        }
      },
      "13": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 17
        }
      },
      "14": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 72
        }
      },
      "15": {
        start: {
          line: 95,
          column: 16
        },
        end: {
          line: 116,
          column: 3
        }
      },
      "16": {
        start: {
          line: 95,
          column: 29
        },
        end: {
          line: 116,
          column: 3
        }
      },
      "17": {
        start: {
          line: 96,
          column: 21
        },
        end: {
          line: 100,
          column: 5
        }
      },
      "18": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 104,
          column: 5
        }
      },
      "19": {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 102,
          column: 31
        }
      },
      "20": {
        start: {
          line: 103,
          column: 6
        },
        end: {
          line: 103,
          column: 67
        }
      },
      "21": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 28
        }
      },
      "22": {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 115,
          column: 5
        }
      },
      "23": {
        start: {
          line: 108,
          column: 6
        },
        end: {
          line: 110,
          column: 7
        }
      },
      "24": {
        start: {
          line: 109,
          column: 8
        },
        end: {
          line: 109,
          column: 45
        }
      },
      "25": {
        start: {
          line: 111,
          column: 11
        },
        end: {
          line: 115,
          column: 5
        }
      },
      "26": {
        start: {
          line: 112,
          column: 6
        },
        end: {
          line: 114,
          column: 7
        }
      },
      "27": {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 113,
          column: 43
        }
      },
      "28": {
        start: {
          line: 119,
          column: 53
        },
        end: {
          line: 119,
          column: 63
        }
      },
      "29": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 135,
          column: 6
        }
      },
      "30": {
        start: {
          line: 139,
          column: 0
        },
        end: {
          line: 178,
          column: 2
        }
      },
      "31": {
        start: {
          line: 180,
          column: 0
        },
        end: {
          line: 189,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 18,
            column: 15
          },
          end: {
            line: 18,
            column: 16
          }
        },
        loc: {
          start: {
            line: 18,
            column: 29
          },
          end: {
            line: 18,
            column: 46
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 10
          },
          end: {
            line: 19,
            column: 11
          }
        },
        loc: {
          start: {
            line: 19,
            column: 19
          },
          end: {
            line: 19,
            column: 29
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 20,
            column: 18
          },
          end: {
            line: 20,
            column: 19
          }
        },
        loc: {
          start: {
            line: 20,
            column: 27
          },
          end: {
            line: 20,
            column: 45
          }
        },
        line: 20
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 21,
            column: 24
          },
          end: {
            line: 21,
            column: 25
          }
        },
        loc: {
          start: {
            line: 21,
            column: 34
          },
          end: {
            line: 21,
            column: 94
          }
        },
        line: 21
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 30,
            column: 10
          },
          end: {
            line: 30,
            column: 11
          }
        },
        loc: {
          start: {
            line: 31,
            column: 10
          },
          end: {
            line: 33,
            column: 23
          }
        },
        line: 31
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 36,
            column: 24
          },
          end: {
            line: 36,
            column: 25
          }
        },
        loc: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 38,
            column: 29
          }
        },
        line: 37
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 52,
            column: 24
          },
          end: {
            line: 52,
            column: 25
          }
        },
        loc: {
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 54,
            column: 29
          }
        },
        line: 53
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 68,
            column: 15
          },
          end: {
            line: 68,
            column: 16
          }
        },
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 92
          }
        },
        line: 69
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 73,
            column: 15
          },
          end: {
            line: 73,
            column: 16
          }
        },
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 92
          }
        },
        line: 74
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        loc: {
          start: {
            line: 87,
            column: 21
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 87
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 95,
            column: 16
          },
          end: {
            line: 95,
            column: 17
          }
        },
        loc: {
          start: {
            line: 95,
            column: 29
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 95
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 95,
            column: 29
          },
          end: {
            line: 95,
            column: 30
          }
        },
        loc: {
          start: {
            line: 95,
            column: 38
          },
          end: {
            line: 116,
            column: 3
          }
        },
        line: 95
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 118,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        },
        loc: {
          start: {
            line: 118,
            column: 11
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 118
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 181,
            column: 12
          },
          end: {
            line: 181,
            column: 13
          }
        },
        loc: {
          start: {
            line: 181,
            column: 18
          },
          end: {
            line: 181,
            column: 20
          }
        },
        line: 181
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 182,
            column: 10
          },
          end: {
            line: 182,
            column: 11
          }
        },
        loc: {
          start: {
            line: 182,
            column: 16
          },
          end: {
            line: 182,
            column: 18
          }
        },
        line: 182
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 34
          },
          end: {
            line: 21,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 21,
            column: 50
          },
          end: {
            line: 21,
            column: 82
          }
        }, {
          start: {
            line: 21,
            column: 85
          },
          end: {
            line: 21,
            column: 94
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 10
          },
          end: {
            line: 33,
            column: 23
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 14
          },
          end: {
            line: 32,
            column: 98
          }
        }, {
          start: {
            line: 33,
            column: 14
          },
          end: {
            line: 33,
            column: 23
          }
        }],
        line: 31
      },
      "2": {
        loc: {
          start: {
            line: 31,
            column: 10
          },
          end: {
            line: 31,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 10
          },
          end: {
            line: 31,
            column: 32
          }
        }, {
          start: {
            line: 31,
            column: 36
          },
          end: {
            line: 31,
            column: 60
          }
        }],
        line: 31
      },
      "3": {
        loc: {
          start: {
            line: 32,
            column: 14
          },
          end: {
            line: 32,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 26
          }
        }, {
          start: {
            line: 32,
            column: 30
          },
          end: {
            line: 32,
            column: 47
          }
        }, {
          start: {
            line: 32,
            column: 51
          },
          end: {
            line: 32,
            column: 79
          }
        }, {
          start: {
            line: 32,
            column: 84
          },
          end: {
            line: 32,
            column: 98
          }
        }],
        line: 32
      },
      "4": {
        loc: {
          start: {
            line: 37,
            column: 10
          },
          end: {
            line: 38,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 37,
            column: 11
          },
          end: {
            line: 37,
            column: 22
          }
        }, {
          start: {
            line: 37,
            column: 26
          },
          end: {
            line: 37,
            column: 43
          }
        }, {
          start: {
            line: 37,
            column: 47
          },
          end: {
            line: 37,
            column: 80
          }
        }, {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 29
          }
        }],
        line: 37
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 54,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 11
          },
          end: {
            line: 53,
            column: 22
          }
        }, {
          start: {
            line: 53,
            column: 26
          },
          end: {
            line: 53,
            column: 43
          }
        }, {
          start: {
            line: 53,
            column: 47
          },
          end: {
            line: 53,
            column: 80
          }
        }, {
          start: {
            line: 54,
            column: 10
          },
          end: {
            line: 54,
            column: 29
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 9
          },
          end: {
            line: 69,
            column: 20
          }
        }, {
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 41
          }
        }, {
          start: {
            line: 69,
            column: 45
          },
          end: {
            line: 69,
            column: 73
          }
        }, {
          start: {
            line: 69,
            column: 78
          },
          end: {
            line: 69,
            column: 92
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 74,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 9
          },
          end: {
            line: 74,
            column: 20
          }
        }, {
          start: {
            line: 74,
            column: 24
          },
          end: {
            line: 74,
            column: 41
          }
        }, {
          start: {
            line: 74,
            column: 45
          },
          end: {
            line: 74,
            column: 73
          }
        }, {
          start: {
            line: 74,
            column: 78
          },
          end: {
            line: 74,
            column: 92
          }
        }],
        line: 74
      },
      "8": {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 104,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 101
      },
      "9": {
        loc: {
          start: {
            line: 101,
            column: 8
          },
          end: {
            line: 101,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 8
          },
          end: {
            line: 101,
            column: 27
          }
        }, {
          start: {
            line: 101,
            column: 31
          },
          end: {
            line: 101,
            column: 56
          }
        }],
        line: 101
      },
      "10": {
        loc: {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 115,
            column: 5
          }
        }, {
          start: {
            line: 111,
            column: 11
          },
          end: {
            line: 115,
            column: 5
          }
        }],
        line: 107
      },
      "11": {
        loc: {
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 110,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 6
          },
          end: {
            line: 110,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 108
      },
      "12": {
        loc: {
          start: {
            line: 111,
            column: 11
          },
          end: {
            line: 115,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 11
          },
          end: {
            line: 115,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 111
      },
      "13": {
        loc: {
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 114,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 6
          },
          end: {
            line: 114,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 112
      },
      "14": {
        loc: {
          start: {
            line: 121,
            column: 26
          },
          end: {
            line: 121,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 121,
            column: 59
          },
          end: {
            line: 121,
            column: 74
          }
        }, {
          start: {
            line: 121,
            column: 77
          },
          end: {
            line: 121,
            column: 79
          }
        }],
        line: 121
      },
      "15": {
        loc: {
          start: {
            line: 121,
            column: 26
          },
          end: {
            line: 121,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 121,
            column: 26
          },
          end: {
            line: 121,
            column: 33
          }
        }, {
          start: {
            line: 121,
            column: 37
          },
          end: {
            line: 121,
            column: 56
          }
        }],
        line: 121
      },
      "16": {
        loc: {
          start: {
            line: 128,
            column: 14
          },
          end: {
            line: 130,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 14
          },
          end: {
            line: 128,
            column: 21
          }
        }, {
          start: {
            line: 128,
            column: 25
          },
          end: {
            line: 130,
            column: 11
          }
        }],
        line: 128
      },
      "17": {
        loc: {
          start: {
            line: 131,
            column: 21
          },
          end: {
            line: 131,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 131,
            column: 43
          },
          end: {
            line: 131,
            column: 64
          }
        }, {
          start: {
            line: 131,
            column: 67
          },
          end: {
            line: 131,
            column: 69
          }
        }],
        line: 131
      },
      "18": {
        loc: {
          start: {
            line: 132,
            column: 11
          },
          end: {
            line: 132,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 11
          },
          end: {
            line: 132,
            column: 29
          }
        }, {
          start: {
            line: 132,
            column: 33
          },
          end: {
            line: 132,
            column: 81
          }
        }],
        line: 132
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1b50abbe506ef21d4588ea187a3ee625f1d07441"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_23vybfxuk0 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_23vybfxuk0();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_23vybfxuk0().s[0]++, _stylingConstants.default),
  color = _ref.color;
var Wrapper = (cov_23vybfxuk0().s[1]++, _styledComponents.default.div.attrs({
  className: 'g-Input'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)([""]))));
var StyledInput = (cov_23vybfxuk0().s[2]++, (0, _utils.withThemedStyles)(_styledComponents.default.input.attrs({
  className: function className(_ref2) {
    var type = _ref2.type;
    cov_23vybfxuk0().f[0]++;
    cov_23vybfxuk0().s[3]++;
    return "g-Input-".concat(type);
  },
  type: function type(props) {
    cov_23vybfxuk0().f[1]++;
    cov_23vybfxuk0().s[4]++;
    return props.type;
  },
  autocomplete: function autocomplete(props) {
    cov_23vybfxuk0().f[2]++;
    cov_23vybfxuk0().s[5]++;
    return props.autocomplete;
  },
  'aria-describedby': function ariaDescribedby(props) {
    cov_23vybfxuk0().f[3]++;
    cov_23vybfxuk0().s[6]++;
    return props.errorId ? (cov_23vybfxuk0().b[0][0]++, "g-Input-error-".concat(props.errorId)) : (cov_23vybfxuk0().b[0][1]++, undefined);
  }
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      box-sizing: border-box;\n      padding: 0.75em 0;\n      border: none;\n      border-bottom: 1px solid\n        ", ";\n      outline: none;\n      &:focus {\n        border-color: ", ";\n      }\n    "])), function (props) {
  cov_23vybfxuk0().f[4]++;
  cov_23vybfxuk0().s[7]++;
  return (cov_23vybfxuk0().b[2][0]++, props.isError === true) || (cov_23vybfxuk0().b[2][1]++, props.validationErrorMsg) ? (cov_23vybfxuk0().b[1][0]++, (cov_23vybfxuk0().b[3][0]++, props.theme) && (cov_23vybfxuk0().b[3][1]++, props.theme.input) && (cov_23vybfxuk0().b[3][2]++, props.theme.input.errorColor) || (cov_23vybfxuk0().b[3][3]++, color.negative)) : (cov_23vybfxuk0().b[1][1]++, '#e6e6e6');
}, function (props) {
  cov_23vybfxuk0().f[5]++;
  cov_23vybfxuk0().s[8]++;
  return (cov_23vybfxuk0().b[4][0]++, props.theme) && (cov_23vybfxuk0().b[4][1]++, props.theme.input) && (cov_23vybfxuk0().b[4][2]++, props.theme.input.backgroundColor) || (cov_23vybfxuk0().b[4][3]++, color.boxBackground);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      box-sizing: border-box;\n      outline: none;\n      border: var(--dividerWidth, 1px) solid var(--dividerColor, #d5d5d9);\n      border-radius: var(--generalBorderRadius, 12px);\n      padding: ", "px;\n      margin-top: ", "px;\n      height: 48px;\n      background-clip: text;\n      &:focus {\n        border-color: ", ";\n      }\n    "])), _themeMapper.evolutionTheme.spacings.md, _themeMapper.evolutionTheme.spacings.md, function (props) {
  cov_23vybfxuk0().f[6]++;
  cov_23vybfxuk0().s[9]++;
  return (cov_23vybfxuk0().b[5][0]++, props.theme) && (cov_23vybfxuk0().b[5][1]++, props.theme.input) && (cov_23vybfxuk0().b[5][2]++, props.theme.input.backgroundColor) || (cov_23vybfxuk0().b[5][3]++, color.boxBackground);
}))));
var ErrorMessage = (cov_23vybfxuk0().s[10]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-Input-error"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: 0.8em;\n      height: 1em;\n      color: ", ";\n    "])), function (props) {
  cov_23vybfxuk0().f[7]++;
  cov_23vybfxuk0().s[11]++;
  return (cov_23vybfxuk0().b[6][0]++, props.theme) && (cov_23vybfxuk0().b[6][1]++, props.theme.input) && (cov_23vybfxuk0().b[6][2]++, props.theme.input.errorColor) || (cov_23vybfxuk0().b[6][3]++, color.negative);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      font-size: 0.8em;\n      color: ", ";\n      height: 0;\n      span {\n        font-size: ", ";\n      }\n    "])), function (props) {
  cov_23vybfxuk0().f[8]++;
  cov_23vybfxuk0().s[12]++;
  return (cov_23vybfxuk0().b[7][0]++, props.theme) && (cov_23vybfxuk0().b[7][1]++, props.theme.input) && (cov_23vybfxuk0().b[7][2]++, props.theme.input.errorColor) || (cov_23vybfxuk0().b[7][3]++, color.negative);
}, _themeMapper.evolutionTheme.typography.caption1.fontSize))));

/**
 * Component to draw an Input element
 */
var Input = /*#__PURE__*/function (_PureComponent) {
  function Input(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Input);
    cov_23vybfxuk0().f[9]++;
    cov_23vybfxuk0().s[13]++;
    _this = _callSuper(this, Input, [props]);
    /**
     * Method to handle onChange and onBlur events. They calculate new state and pass the information to the parent component over onChange and onBlur props.
     */
    (0, _defineProperty2.default)(_this, "handleEvent", (cov_23vybfxuk0().s[15]++, function (eventName) {
      cov_23vybfxuk0().f[10]++;
      cov_23vybfxuk0().s[16]++;
      return function (event) {
        cov_23vybfxuk0().f[11]++;
        var newState = (cov_23vybfxuk0().s[17]++, {
          value: event.target.value,
          isValid: true,
          validationErrorMsg: ''
        });
        cov_23vybfxuk0().s[18]++;
        if ((cov_23vybfxuk0().b[9][0]++, _this.props.required) && (cov_23vybfxuk0().b[9][1]++, event.target.value === '')) {
          cov_23vybfxuk0().b[8][0]++;
          cov_23vybfxuk0().s[19]++;
          newState.isValid = false;
          cov_23vybfxuk0().s[20]++;
          newState.validationErrorMsg = 'gravity.Input.errorMandatory';
        } else {
          cov_23vybfxuk0().b[8][1]++;
        }
        cov_23vybfxuk0().s[21]++;
        _this.setState(newState);
        // If onChange or onBlur are coming as props, the parent component will receive the new state.
        cov_23vybfxuk0().s[22]++;
        if (eventName === 'change') {
          cov_23vybfxuk0().b[10][0]++;
          cov_23vybfxuk0().s[23]++;
          if (_this.props.onChange) {
            cov_23vybfxuk0().b[11][0]++;
            cov_23vybfxuk0().s[24]++;
            _this.props.onChange(event, newState);
          } else {
            cov_23vybfxuk0().b[11][1]++;
          }
        } else {
          cov_23vybfxuk0().b[10][1]++;
          cov_23vybfxuk0().s[25]++;
          if (eventName === 'blur') {
            cov_23vybfxuk0().b[12][0]++;
            cov_23vybfxuk0().s[26]++;
            if (_this.props.onBlur) {
              cov_23vybfxuk0().b[13][0]++;
              cov_23vybfxuk0().s[27]++;
              _this.props.onBlur(event, newState);
            } else {
              cov_23vybfxuk0().b[13][1]++;
            }
          } else {
            cov_23vybfxuk0().b[12][1]++;
          }
        }
      };
    }));
    cov_23vybfxuk0().s[14]++;
    _this.state = {
      value: '',
      isValid: null,
      validationErrorMsg: null
    };
    return _this;
  }
  (0, _inherits2.default)(Input, _PureComponent);
  return (0, _createClass2.default)(Input, [{
    key: "render",
    value: function render() {
      cov_23vybfxuk0().f[12]++;
      var _ref3 = (cov_23vybfxuk0().s[28]++, this.props),
        isError = _ref3.isError,
        validationErrorMsg = _ref3.validationErrorMsg,
        errorId = _ref3.errorId;
      cov_23vybfxuk0().s[29]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        className: (cov_23vybfxuk0().b[15][0]++, isError) || (cov_23vybfxuk0().b[15][1]++, !this.state.isValid) ? (cov_23vybfxuk0().b[14][0]++, 'g-Input-error') : (cov_23vybfxuk0().b[14][1]++, ''),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(StyledInput, (0, _extends2.default)({}, this.props, {
        onChange: this.handleEvent('change'),
        onBlur: this.handleEvent('blur'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122,
          columnNumber: 9
        }
      })), /*#__PURE__*/_react.default.createElement(ErrorMessage, (0, _extends2.default)({}, (cov_23vybfxuk0().b[16][0]++, errorId) && (cov_23vybfxuk0().b[16][1]++, {
        id: "g-Input-error-".concat(errorId)
      }), {
        className: !validationErrorMsg ? (cov_23vybfxuk0().b[17][0]++, 'g-Input-error-empty') : (cov_23vybfxuk0().b[17][1]++, ''),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127,
          columnNumber: 9
        }
      }), (cov_23vybfxuk0().b[18][0]++, validationErrorMsg) && (cov_23vybfxuk0().b[18][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: validationErrorMsg,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 132,
          columnNumber: 34
        }
      }))));
    }
  }]);
}(_react.PureComponent);
cov_23vybfxuk0().s[30]++;
Input.propTypes = {
  /**
   * It handles onChange event for the input. It will return back the following parameters:
   *
   * @param {object} event, event information triggered by the event handler
   * @param {object} newState, info of the current state
   */
  onChange: _propTypes.default.func,
  /**
   * It handles onBlur event for the input. It will return back the following parameters:
   *
   * @param {object} event, event information triggered by the event handler
   * @param {object} newState, info of the current state
   */
  onBlur: _propTypes.default.func,
  /**
   * Boolean, true if we want to display the error
   */
  isError: _propTypes.default.bool,
  /**
   * It is the message will be shown when the value doesn't pass the validation
   */
  validationErrorMsg: _propTypes.default.string,
  /**
   * It is definign the type of the input is going to be created
   */
  type: _propTypes.default.string,
  /**
   * Boolean, true is the field must be mandatory, so it will modify isValid state when has some value
   */
  required: _propTypes.default.bool,
  /**
   * Value of the autocomplete attribute for the input field.
   */
  autocomplete: _propTypes.default.string,
  /**
   * The id of validationErrorMsg
   */
  errorId: _propTypes.default.string
};
cov_23vybfxuk0().s[31]++;
Input.defaultProps = {
  onChange: function onChange() {
    cov_23vybfxuk0().f[13]++;
  },
  onBlur: function onBlur() {
    cov_23vybfxuk0().f[14]++;
  },
  isError: false,
  validationErrorMsg: '',
  type: 'text',
  required: false,
  autocomplete: 'on',
  errorId: ''
};
var _default = exports.default = Input;